// RAID サマーインターン2026 LP のコンテンツ定数。
// 出典: Notion「(仕様)サマーインターン_LP」。原稿確定後はこの定数を更新する。

export const FIRST_VIEW = {
  brand: 'RAID',
  subtitle: '- 日本トレカセンター サマーインターン2026 -',
  schedule: '2026.9.24.THU - 9.27.SUN @TOKYO',
};

// フライヤー準拠の日程表示（色分け単位）。
export const SCHEDULE_LINE = [
  { text: '2026', tone: 'year' },
  { text: '.', tone: 'neutral' },
  { text: '9', tone: 'accent' },
  { text: '.', tone: 'neutral' },
  { text: '24', tone: 'accent' },
  { text: '.THU', tone: 'neutral' },
  { text: ' - ', tone: 'neutral' },
  { text: '9', tone: 'accent' },
  { text: '.', tone: 'neutral' },
  { text: '27', tone: 'accent' },
  { text: '.SUN', tone: 'neutral' },
  { text: ' @TOKYO', tone: 'location' },
];

// PDF フライヤー「参加特典」準拠。各カードの構成要素を分解して保持する。
// media.ready が true になったら src の画像に差し替える（false の間は仮置き枠を表示）。
export const BENEFITS = [
  {
    no: '01',
    hero: true,
    eyebrow: 'SPECIAL BENEFIT FOR PARTICIPANTS',
    lead: [{ t: 'インターン修了者 ' }, { t: '全員', em: true }, { t: 'に' }],
    highlight: 'Apple Mac mini',
    after: 'プレゼント!!',
    media: {
      src: 'benefit_01_macmini.png',
      label: 'Mac mini 製品画像',
      ready: true,
    },
  },
  {
    no: '02',
    eyebrow: 'PAID INTERSHIP',
    lead: '有給インターン',
    pre: '時給',
    highlight: '10,000円',
    after: '支給!!',
  },
  {
    no: '03',
    eyebrow: 'SPECIAL BENEFIT FOR PARTICIPANTS',
    pre: '優勝賞金',
    highlight: '100万円',
    unit: '／人',
    sub: '新規事業発足チャンスあり',
    media: {
      src: 'benefit_03_laurel.svg',
      label: '月桂冠',
      ready: true,
      decorative: true,
      flank: true,
    },
  },
  {
    no: '04',
    eyebrow: 'SPECIAL BENEFIT FOR PARTICIPANTS',
    lead: '対面選考からインターンまで',
    highlight: '交通費・宿泊費',
    strong: '全額支給',
    media: {
      src: 'benefit_04_travel.svg',
      label: '交通費・宿泊費アイコン',
      ready: true,
    },
  },
  {
    no: '05',
    eyebrow: 'SPECIAL BENEFIT FOR PARTICIPANTS',
    body: 'インターンの全過程が動画コンテンツ化・SNS公開予定',
    media: {
      src: 'benefit_05_video.svg',
      label: '動画カメラアイコン',
      ready: true,
    },
    sns: ['sns_youtube.svg', 'sns_instagram.svg'],
  },
];

export const BENEFITS_NOTE =
  '※インターン期間中は映像制作会社による撮影が入ります。撮影した映像は日本トレカセンターのYouTube・SNS・採用広報等で公開予定です。参加にあたり映像使用への同意をエントリーフォームにてお願いしております。';

export const RAID_INTRO = {
  lead: ['日本トレカセンターが開催する', '4日間の短期集中インターン'],
  paragraphs: [
    [
      'AIを駆使して、',
      '日本トレカセンターの次のエンターテイメント事業を立案。',
    ],
    [
      '最終日には、経営陣へ直接ピッチし、',
      '優秀案は実際に事業化され、予算が支給。',
    ],
    ['座学や就業体験ではありません。'],
    ['本当に動くビジネスを、', '学生が4日間で作り切る。'],
  ],
  closing: ['この夏、RAIDで', '未来を引きにいけ。'],
};

export const COMPANY = {
  catch: '急成長企業で働きたいあなたへ',
  description: [
    '設立わずか3年で、日本最大級に。',
    '業界トップクラスまで駆け上がった急成長スタートアップ。',
  ],
  metrics: [
    {
      label: '売上成長率',
      value: [{ t: '毎年3倍', accent: true }],
    },
    {
      label: '月間売上',
      value: [
        { t: '二桁億円', accent: true },
        { t: '達成', sub: true },
      ],
    },
    {
      label: 'グローバル展開',
      value: [{ t: '海外進出開始', accent: true }],
    },
  ],
};

const WANTEDLY_BASE =
  'https://www.wantedly.com/companies/company_5841931/post_articles';

// 記事追加時はここに追記するだけ。PC カルーセル開始位置は PeopleInterviews 側で自動計算。
export const RAID_PEOPLE_INTERVIEWS = [
  {
    id: 'people-01',
    image: 'people/people_01.webp',
    href: `${WANTEDLY_BASE}/1067271`,
    label: 'INTERVIEW 01',
    department: '人事部',
    role: '採用広報',
  },
  {
    id: 'people-02',
    image: 'people/people_02.webp',
    href: `${WANTEDLY_BASE}/1067287`,
    label: 'INTERVIEW 02',
    department: 'プロダクト部',
    role: 'アナリスト',
  },
  {
    id: 'people-03',
    image: 'people/people_03.webp',
    href: `${WANTEDLY_BASE}/1067291`,
    label: 'INTERVIEW 03',
    department: '社長室',
    role: '経営企画',
  },
  {
    id: 'people-04',
    image: 'people/people_04.webp',
    href: `${WANTEDLY_BASE}/1068396`,
    label: 'INTERVIEW 04',
    department: 'グロース部',
    role: '部長',
  },
  {
    id: 'people-05',
    image: 'people/people_05.webp',
    href: `${WANTEDLY_BASE}/1068401`,
    label: 'INTERVIEW 05',
    department: 'Ops部',
    role: 'スペシャリスト',
  },
  {
    id: 'people-06',
    image: 'people/people_06.webp',
    href: `${WANTEDLY_BASE}/1068402`,
    label: 'INTERVIEW 06',
    department: 'グロース部',
    role: 'マネージャー',
  },
  {
    id: 'people-07',
    image: 'people/people_07.webp',
    href: `${WANTEDLY_BASE}/1069354`,
    label: 'INTERVIEW 07',
    department: '人事部',
    role: '部長',
  },
  {
    id: 'people-08',
    image: 'people/people_08.webp',
    href: `${WANTEDLY_BASE}/1069356`,
    label: 'INTERVIEW 08',
    department: 'Ops部',
    role: 'リーダー',
  },
  {
    id: 'people-09',
    image: 'people/people_09.webp',
    href: `${WANTEDLY_BASE}/1070203`,
    label: 'INTERVIEW 09',
    department: 'オリパ企画部',
    role: 'リーダー',
  },
  {
    id: 'people-10',
    image: 'people/people_10.webp',
    href: `${WANTEDLY_BASE}/1070212`,
    label: 'INTERVIEW 10',
    department: 'オリパ企画部',
    role: 'マネージャー',
  },
  {
    id: 'people-11',
    image: 'people/people_11.webp',
    href: `${WANTEDLY_BASE}/1070609`,
    label: 'INTERVIEW 11',
    department: 'オリパ企画部',
    role: 'リーダー',
  },
  {
    id: 'people-12',
    image: 'people/people_12.webp',
    href: `${WANTEDLY_BASE}/1070611`,
    label: 'INTERVIEW 12',
    department: 'オリパ企画部',
    role: 'メンバー',
  },
  {
    id: 'people-13',
    image: 'people/people_13.webp',
    href: `${WANTEDLY_BASE}/1070606`,
    label: 'INTERVIEW 13',
    department: 'Ops部',
    role: 'リーダー',
  },
  {
    id: 'people-14',
    image: 'people/people_14.webp',
    href: `${WANTEDLY_BASE}/1071371`,
    label: 'INTERVIEW 14',
    department: '管理部',
    role: '部長',
  },
  {
    id: 'people-15',
    image: 'people/people_15.webp',
    href: `${WANTEDLY_BASE}/1071372`,
    label: 'INTERVIEW 15',
    department: 'オリパ企画部',
    role: 'マネージャー',
  },
  {
    id: 'people-16',
    image: 'people/people_16.webp',
    href: `${WANTEDLY_BASE}/1072164`,
    label: 'INTERVIEW 16',
    title: '代表インタビュー',
    department: '代表',
    role: '代表取締役CEO',
  },
  {
    id: 'people-17',
    image: 'people/people_17.webp',
    href: `${WANTEDLY_BASE}/1073124`,
    label: 'INTERVIEW 17',
    department: 'Ops部',
    role: '部長',
  },
  {
    id: 'people-18',
    image: 'people/people_18.webp',
    href: `${WANTEDLY_BASE}/1073128`,
    label: 'INTERVIEW 18',
    department: 'プロダクト部',
    role: 'マネージャー',
  },
  {
    id: 'people-19',
    image: 'people/people_19.webp',
    href: `${WANTEDLY_BASE}/1073585`,
    label: 'INTERVIEW 19',
    department: 'グロース部',
    role: 'メンバー',
  },
  {
    id: 'people-20',
    image: 'people/people_20.webp',
    href: `${WANTEDLY_BASE}/1073588`,
    label: 'INTERVIEW 20',
    department: '社長室',
    role: '秘書',
  },
  {
    id: 'people-21',
    image: 'people/people_21.webp',
    href: `${WANTEDLY_BASE}/1073590`,
    label: 'INTERVIEW 21',
    department: '人事部',
    role: '採用人事',
  },
  {
    id: 'people-22',
    image: 'people/people_22.webp',
    href: `${WANTEDLY_BASE}/1074207`,
    label: 'INTERVIEW 22',
    department: '経営企画部',
    role: 'マネージャー',
  },
  {
    id: 'people-23',
    image: 'people/people_23.webp',
    href: `${WANTEDLY_BASE}/1074212`,
    label: 'INTERVIEW 23',
    department: '経営戦略室',
    role: '部長',
  },
  {
    id: 'people-24',
    image: 'people/people_24.webp',
    href: `${WANTEDLY_BASE}/1074210`,
    label: 'INTERVIEW 24',
    department: 'オリパ企画部',
    role: 'マネージャー',
  },
  {
    id: 'people-25',
    image: 'people/people_25.webp',
    href: `${WANTEDLY_BASE}/1074536`,
    label: 'INTERVIEW 25',
    department: 'グロース部',
    role: 'マーケター',
  },
  {
    id: 'people-26',
    image: 'people/people_26.webp',
    href: `${WANTEDLY_BASE}/1074540`,
    label: 'INTERVIEW 26',
    title: '取締役インタビュー',
    department: '取締役',
    role: 'プロダクト部長',
  },
  {
    id: 'people-27',
    image: 'people/people_27.webp',
    href: `${WANTEDLY_BASE}/1074546`,
    label: 'INTERVIEW 27',
    department: 'プロダクト部',
    role: 'デザイナー',
  },
  {
    id: 'people-28',
    image: 'people/people_28.webp',
    href: `${WANTEDLY_BASE}/1074551`,
    label: 'INTERVIEW 28',
    department: 'グロース部',
    role: 'マーケター',
  },
  {
    id: 'people-29',
    image: 'people/people_29.webp',
    href: `${WANTEDLY_BASE}/1074947`,
    label: 'INTERVIEW 29',
    department: 'オリパ企画部',
    role: 'リーダー',
  },
  {
    id: 'people-30',
    image: 'people/people_30.webp',
    href: `${WANTEDLY_BASE}/1074949`,
    label: 'INTERVIEW 30',
    department: 'Ops部',
    role: 'リーダー',
  },
  {
    id: 'people-31',
    image: 'people/people_31.webp',
    href: `${WANTEDLY_BASE}/1074950`,
    label: 'INTERVIEW 31',
    department: 'プロダクト部',
    role: 'エンジニア',
  },
  {
    id: 'people-32',
    image: 'people/people_32.webp',
    href: `${WANTEDLY_BASE}/1074952`,
    label: 'INTERVIEW 32',
    department: '海外事業開発',
    role: '創業メンバー',
  },
  {
    id: 'people-33',
    image: 'people/people_33.webp',
    href: `${WANTEDLY_BASE}/1074953`,
    label: 'INTERVIEW 33',
    department: 'オリパ企画部',
    role: 'リーダー',
  },
  {
    id: 'people-34',
    image: 'people/people_34.webp',
    href: `${WANTEDLY_BASE}/1075522`,
    label: 'INTERVIEW 34',
    department: 'Ops部',
    role: '在庫管理リーダー',
  },
  {
    id: 'people-35',
    image: 'people/people_35.webp',
    href: `${WANTEDLY_BASE}/1075528`,
    label: 'INTERVIEW 35',
    department: 'プロダクト部',
    role: 'エンジニアマネージャー',
  },
  {
    id: 'people-36',
    image: 'people/people_36.webp',
    href: `${WANTEDLY_BASE}/1075533`,
    label: 'INTERVIEW 36',
    department: '社長室',
    role: '秘書',
  },
  {
    id: 'people-37',
    image: 'people/people_37.webp',
    href: `${WANTEDLY_BASE}/1075537`,
    label: 'INTERVIEW 37',
    department: 'オリパ企画部',
    role: 'リーダー',
  },
  {
    id: 'people-38',
    image: 'people/people_38.webp',
    href: `${WANTEDLY_BASE}/1075538`,
    label: 'INTERVIEW 38',
    department: 'プロダクト部',
    role: 'プロダクトマネージャー',
  },
  {
    id: 'people-39',
    image: 'people/people_39.webp',
    href: `${WANTEDLY_BASE}/1075664`,
    label: 'INTERVIEW 39',
    department: 'オリパ企画部',
    role: 'メンバー',
  },
  {
    id: 'people-40',
    image: 'people/people_40.webp',
    href: `${WANTEDLY_BASE}/1075665`,
    label: 'INTERVIEW 40',
    department: 'グロース部',
    role: 'デザイナー',
  },
  {
    id: 'people-41',
    image: 'people/people_41.webp',
    href: `${WANTEDLY_BASE}/1075667`,
    label: 'INTERVIEW 41',
    department: 'プロダクト部',
    role: 'プロダクトマネージャー',
  },
  {
    id: 'people-42',
    image: 'people/people_42.webp',
    href: `${WANTEDLY_BASE}/1075670`,
    label: 'INTERVIEW 42',
    department: '人事部',
    role: '採用アシスタント',
  },
  {
    id: 'people-43',
    image: 'people/people_43.webp',
    href: `${WANTEDLY_BASE}/1075673`,
    label: 'INTERVIEW 43',
    department: 'オリパ企画部',
    role: 'メンバー',
  },
  {
    id: 'people-44',
    image: 'people/people_44.webp',
    href: `${WANTEDLY_BASE}/1075649`,
    label: 'INTERVIEW 44',
    department: 'グロース部',
    role: 'リーダー',
  },
  {
    id: 'people-45',
    image: 'people/people_45.webp',
    href: `${WANTEDLY_BASE}/1076012`,
    label: 'INTERVIEW 45',
    department: 'プロダクト部',
    role: 'プロダクトマネージャー',
  },
  {
    id: 'people-46',
    image: 'people/people_46.webp',
    href: `${WANTEDLY_BASE}/1076015`,
    label: 'INTERVIEW 46',
    department: 'オリパ企画部',
    role: 'リーダー',
  },
  {
    id: 'people-47',
    image: 'people/people_47.webp',
    href: `${WANTEDLY_BASE}/1076016`,
    label: 'INTERVIEW 47',
    department: 'オリパ企画部',
    role: 'リーダー',
  },
  {
    id: 'people-48',
    image: 'people/people_48.webp',
    href: `${WANTEDLY_BASE}/1076018`,
    label: 'INTERVIEW 48',
    department: 'グロース部',
    role: 'デザイナー',
  },
  {
    id: 'people-49',
    image: 'people/people_49.webp',
    href: `${WANTEDLY_BASE}/1076019`,
    label: 'INTERVIEW 49',
    department: 'オリパ企画部',
    role: '営業担当',
  },
];

export const RECOMMENDED = [
  'AIを使い倒したい方',
  '10倍・100倍の価値創造を目指したい方',
  'ゼロから事業を作ることに挑戦したい方',
];

// フライヤー「Who's ready for the raid?」帯の緑グラデ（RAID_a4_flyer_ver_A からサンプリング）。
export const WHO_READY_GREEN_GRADIENT = {
  from: '#B2DC62',
  to: '#2E7330',
};

export const OVERVIEW = [
  { label: '日程', value: '2026年9月24日（木）〜27日（日）' },
  { label: '場所', value: '東京' },
  { label: '定員', value: '30〜40名（選抜制）' },
  {
    label: 'テーマ',
    value: '日本トレカセンターの次のエンターテイメント事業を立案せよ。',
  },
];

export const ELIGIBILITY = [
  '2028年4月以降に\n新卒入社予定の方',
  '現在大学生 / 大学院生の方\n（年次問わず）',
  '既卒の方もチャレンジ歓迎',
];

// 第1回書類選考（〜7/31）までの選考フロー。
export const SELECTION_FLOW = [
  { step: 'STEP1', body: 'エントリー', icon: 'entry' },
  { step: 'STEP2', body: '書類選考', icon: 'document' },
  { step: 'STEP3', body: '対面選考', icon: 'inPerson' },
  { step: 'STEP4', body: 'オンライン面接', icon: 'onlineInterview' },
  { step: 'STEP5', body: 'インターン本番（9/24〜27）', icon: 'internship' },
];

// 8/1 から始まる特別選考フロー。対面選考を挟まず、書類選考とオンライン面接の2段階にする。
export const SELECTION_FLOW_SPECIAL = [
  { step: 'STEP1', body: 'エントリー', icon: 'entry' },
  { step: 'STEP2', body: '1次選考：書類選考', icon: 'document' },
  { step: 'STEP3', body: '2次選考：オンライン面接', icon: 'onlineInterview' },
  { step: 'STEP4', body: 'インターン本番（9/24〜27）', icon: 'internship' },
];

export const SELECTION_FLOW_HEADING = '選考フロー';
export const SELECTION_FLOW_SPECIAL_HEADING = '特別選考フロー';

// 特別選考は候補者ごとに進め方が変わり得るため、フロー図の下に注釈を添える。
export const SELECTION_FLOW_SPECIAL_NOTE =
  '※通常選考のフローと異なります。特別選考のフローは候補者に応じて変更する場合がございます。';

// エントリー受付終了の告知（2026-09-07 人事依頼）。
// ファーストビューとエントリーセクションで文言を出し分ける。
export const ENTRY_CLOSED = {
  hero: {
    title: 'エントリー受付終了',
    message: 'たくさんのご応募ありがとうございました',
  },
  form: {
    title: 'エントリー受付は終了しました',
    message: 'たくさんのご応募ありがとうございました',
  },
};

export const NOTES = [
  'インターン期間中は映像制作会社による撮影が入ります。撮影した映像は日本トレカセンターのYouTube・SNS・採用広報等で公開予定です。参加にあたり映像使用への同意をエントリーフォームにてお願いしております。同意いただけない方には参加をお断りしております。あらかじめご了承ください。',
  'エントリーだけでは応募完了になりませんので、ご注意くださいませ。応募多数の場合、選考の結果ご参加いただけない場合がございます。',
  '賞品の内容は、変更となる可能性があります。',
  '交通費：会社が定めるルールに従って支給いたします。',
  '宿泊先：遠方在住の方は、会社が宿泊先を手配いたします。',
  '日程・内容は予告なく変更となる場合があります。',
  '本インターンシップは採用を目的としたプログラムです。参加が内定を約束するものではありません。',
];

export const COMPANY_OVERVIEW = {
  eyebrow: 'COMPANY',
  title: '会社概要',
  topLink: {
    label: 'コーポレートサイトTOPへ',
    href: '/',
  },
  // X 認証バッジ審査の要件として LP 内に公式アカウントを掲載する（sc-14386）。
  xLink: {
    handle: '@jtcc_recruit',
    href: 'https://x.com/jtcc_recruit',
  },
  details: [
    { label: '会社名', value: '株式会社日本トレカセンター' },
    { label: '代表者', value: '代表取締役CEO 大山 敏浩' },
    {
      label: '所在地',
      value: '営業部署毎に変わりますので、担当者へお問い合わせください',
    },
    { label: '設立', value: '2023年4月' },
    { label: '資本金', value: '417百万円（資本準備金を含む）' },
  ],
  copyright: '© 2026 JAPAN TRADING CARD CENTER Co., Ltd.',
};

export const CONTACT_EMAIL = 'intern@jtc.center';

export const ENTRY_ANCHOR_ID = 'entry';

// コーポレートサイトTOPの RAID 導線（Raid2026TopCta）用の短縮コピー。
// 値は本ページの既存コピー（RAID_INTRO / BENEFITS）から引用している。
export const RAID_TOP_CTA = {
  summerLabel: 'SUMMER INTERNSHIP 2026',
  catch: RAID_INTRO.closing, // ['この夏、RAIDで', '未来を引きにいけ。']
  highlights: ['全員にMac mini', '時給1万円', '賞金100万円'],
  tagline: 'AIを駆使し、4日間で新規事業を立案する短期集中インターン。',
  buttonLines: ['エントリー受付終了', '特設サイトを見る'],
  buttonLabel: 'エントリー受付終了 ｜ 特設サイトを見る',
};
